import { useCopyToClipboard as useCopyToClipboardNative } from "usehooks-ts";

import { useState } from "react";

export const useCopyToClipboardCurrentPage = () => {
  const [copiedText, copy] = useCopyToClipboardNative();
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    if (typeof window === "undefined") return;
    const completeUrl = window.location.href;
    copy(completeUrl)
      .then(() => {
        setIsCopied(() => true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((error) => {
        console.debug("Failed to copy!", error);
      });
  };

  return {
    isCopied,
    copiedText,
    copyToClipboard,
  };
};
